import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { RefObject } from 'react';

const testimonial = {
  quote: "CJ Solutions has been instrumental in helping us navigate complex compliance requirements, providing clarity and confidence throughout the process. Their team is always professional, responsive, and easy to collaborate with.",
  author: "Michael Andreou",
  position: "CEO at TechFinance Ltd",
  image: "https://public.readdy.ai/ai/img_res/e57e4c93785b65d802aaae45f20ace55.jpg",
  stat: "50+",
  statLabel: "Years of Combined Corporate Experience",
};

export default function Testimonials() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      ref={ref as RefObject<HTMLElement>}
      className="py-16 lg:py-20 bg-slate-50"
    >
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Testimonial Card */}
        <article className="bg-slate-100 rounded-[20px] shadow-lg pt-8 lg:pt-12 px-6 lg:px-12 pb-6 lg:pb-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            {/* Author Info - Optimized with lazy loading */}
            <div className="lg:col-span-4 flex flex-col items-start space-y-4">
              <div className="flex-shrink-0">
                <img
                  className="w-20 h-20 lg:w-24 lg:h-24 rounded-full object-cover shadow-lg"
                  src={testimonial.image}
                  alt={testimonial.author}
                  width={96}
                  height={96}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="text-left">
                <div className="text-xl lg:text-2xl font-semibold text-slate-900">
                  {testimonial.author}
                </div>
                <div className="text-slate-900/80 text-base mt-1">
                  {testimonial.position}
                </div>
              </div>
            </div>

            {/* Quote */}
            <div className="lg:col-span-8">
              <div className="mb-6">
                <i className="ri-double-quotes-l text-4xl text-amber-500"></i>
              </div>
              <blockquote className="text-xl lg:text-2xl font-medium text-slate-900 leading-snug mb-12">
                "{testimonial.quote}"
              </blockquote>
              <div className="border-t border-slate-300 mb-2"></div>
              <div className="py-6">
                <div className="flex flex-row items-center space-x-4">
                  <div className="text-4xl lg:text-5xl font-semibold text-slate-900">
                    {testimonial.stat}
                  </div>
                  <span className="text-2xl text-slate-400 font-light">-</span>
                  <div className="text-lg text-slate-900">
                    {testimonial.statLabel}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Bottom Bar */}
        <header className="bg-slate-900 rounded-b-[20px] shadow-lg py-6 lg:py-8 px-6 lg:px-12 -mt-2">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-6">
            <h2 className="text-2xl lg:text-3xl font-semibold text-white">
              What our clients say about us
            </h2>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-4 py-2 bg-amber-500 hover:bg-amber-600 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="text-white text-base font-semibold">
                Read All Testimonials
              </span>
            </a>
          </div>
        </header>
      </div>
    </section>
  );
}
